import moment from "moment";

export const POSITIONS_WITH_BRANCHES = ["BDO", "LM", "UM", "BAG", "BHOA"];
export const ALL_USER_POSITIONS = ["BDO", "LM", "UM", "BAG", "BHOA", "AG", "HOA", "HOI", "HOP", "DR"]

const USER_POSITIONS = [
  { id: "BDO", label: "Business development officer", permissionLevel: 1 },
  { id: "LM", label: "Line Manager", permissionLevel: 2 },
  { id: "UM", label: "Unit Manager", permissionLevel: 3 },
  { id: "BAG", label: "Branch auditior", permissionLevel: 3 },
  { id: "BHOA", label: "Branch head of accounts", permissionLevel: 3 },
  { id: "AG", label: "Auditior", permissionLevel: 4 },
  { id: "HOI", label: "Head of instpection", permissionLevel: 4 },
  { id: "HOA", label: "Head of accounts", permissionLevel: 4 },
  { id: "HOP", label: "Head of oparations", permissionLevel: 4 },
  { id: "DR", label: "Director", permissionLevel: 5 },
];

export const messagingPositionMapping = {
  BDO: [],
  LM: ["BRANCH", "STAFF"],
  UM: ["BRANCH", "STAFF"],
  BAG: ["BRANCH", "STAFF"],
  BHOA: ["BRANCH", "STAFF"],
  AG: ["BRANCH", "STAFF", "ALL ORG"],
  HOI: ["BRANCH", "STAFF", "ALL ORG"],
  HOA: ["BRANCH", "STAFF", "ALL ORG"],
  HOP: ["BRANCH", "STAFF", "ALL ORG"],
  DR: ["BRANCH", "STAFF", "ALL ORG"],
};

export const BRANCH_LEVEL_POSITIONS = ["LM", "UM", "BAG", "BHOA"];

export const IS_PROD = window.location.hostname === "m.opulentpeerless.com";

export const BASE_API_URL = process.env.REACT_APP_BASE_URL;

function generatePassword() {
  let length = 8,
    charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
    retVal = "";
  for (let i = 0, n = charset?.length; i < length; ++i) {
    retVal += charset.charAt(Math.floor(Math.random() * n));
  }
  return retVal;
}

export const getRelatedOrgFieldMeta = (relatedOrType) => {
  switch (relatedOrType) {
    case "branches":
      return {
        idField: "area_id",
        singularName: "Area",
        type: "areas",
      };
  }
};

export const getOrgDashboardIdField = (type) => {
  // Get id field with org name or position
  switch (type) {
    case "branches":
    case "branch":
      return "branch_id";
    case "BDO":
    case "staff":
    case "staffs":
      return "handler_id";
    default:
      return "";
  }
};

export const getOrgStaffProfileOrgField = (type) => {
  // Get id field with org name or position
  switch (type) {
    case "CO":
    case "cos":
      return "branch";
    case "branches":
    case "branch":
    case "BM":
      return "branch";
    case "areas":
    case "area":
    case "AM":
      return "area";
    case "zones":
    case "zone":
    case "ZM":
      return "zone";
    case "states":
    case "state":
    case "SM":
      return "state";
    default:
      return "";
  }
};

export const positionToOrgMapping = {
  BDO: "branch",
  LM: "branch",
  UM: "branch",
  ZM: "branch",
  BAG: "branch",
  BHOA: "",
  AG: "",
  HOI: "",
  HOA: "",
  HOP: "",
  DR: "",
};

export const positionToOrgMapping2 = {
  CO: "cos",
  BM: "branches",
  AM: "areas",
  ZM: "zones",
  SM: "states",
  DR: "",
};

export const staffCreationPositionMapping = {
  CO: "branches",
  BM: "branches",
  AM: "areas",
  ZM: "zones",
  SM: "states",
  DR: "",
};

export const getPlural = {};

const permissionLevels = {
  CO: 1,
  BM: 2,
  AM: 3,
  ZM: 4,
  SM: 5,
  DR: 6,
};

export const positionsMapping = {
  BDO: "Business development officer",
  BAG: "Branch auditior",
  BHOA: "Branch head of accounts",
  LM: "Line Manager",
  UM: "Unit Manager",
  AG: "Acting Auditior",
  HOA: "Head of accounts",
  HOI: "Head of instpection",
  HOP: "Head of oparations",
  DR: "Director",
};

const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export {
  USER_POSITIONS,
  generatePassword,
  permissionLevels,
  capitalizeFirstLetter,
};

export const getErrorMsg = (message) => ({
  status: "danger",
  message: message || "An error occured, please try again",
});

export const pluraliseOrgLevel = (level) => {
  if (level === "branch") {
    return "branches";
  }
  return `${level}s`;
};

export const hashToken = (token) => {
  if (token) {
    return token.split("").reverse().join("");
  }
};

const getErrorMessageFromRes = async (response) => {
  const data = await response?.json();
  let errorMessage = "";

  if (data?.detail === "Invalid token.") {
    localStorage.removeItem("user_local_token");
    return;
  }

  const errorKeys = Object.keys(data);
  for (let index = 0; index < errorKeys?.length; index++) {
    const field = errorKeys[index];
    errorMessage = errorMessage.concat(`${data[field]} `);
  }
  console.log({ errorMessage });
  throw new Error(errorMessage);
};

export const makeRequest = async (url, method = "GET", data, file = false) => {
  const token = localStorage.getItem("user_local_token");
  const TOKEN_UNAVAILABLE =
    token === "undefined" || token === undefined || token === null;

  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
  };

  if (!TOKEN_UNAVAILABLE) {
    headers["Authorization"] = `Token ${hashToken(token)}`;
  }

  const requestOptions = {
    headers,
    method,
    mode: "cors",
  };

  if (data) {
    requestOptions["body"] = JSON.stringify(data);
  }

  const response = await fetch(url, requestOptions);

  // DELETE requests returna a no content response.

  if (!response?.ok) {
    return getErrorMessageFromRes(response);
  }
  if (response?.status === 204) {
    return {};
  }
  return response?.json();
};

const loanStatus = {
  awaiting_disbursment: "AWAITING DISBURSMENT",
  disbursed: "DISBURSED",
  active: "ACTIVE",
  completed: "COMPLETED",
  default: "DEFAULT",
};

export const LOANS_STATUS = Object.values(loanStatus);
export const MONTHLY_PAY_STATUS = ["INACTIVE", "PAID", "UNPAID"];

export const getStatusClassName = (status) => {
  switch (status) {
    case loanStatus.awaiting_disbursment:
      return "badge-dark";
    case loanStatus.completed:
      return "badge-success";
    case loanStatus.default:
      return "badge-danger";
    case loanStatus.disbursed:
      return "badge-secondary";
    case loanStatus.active:
      return "badge-primary";
    default:
      return "";
  }
};

export const fallbackImg =
  "data:image/png;base64,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";

export const MESSAGE_RECIPIENT_TYPE = [
  "STATE",
  "ZONE",
  "AREA",
  "BRANCH",
  "STAFF",
];

export const getSingularOrgListName = (name) => {
  switch (name?.toLowerCase()) {
    case "branches":
    case "branch":
      return "Branch";
    case "zones":
    case "zone":
      return "Zone";
    case "areas":
    case "area":
      return "Area";
    case "states":
    case "state":
      return "State";
    default:
      return "";
  }
};

export const getTotal = (data) => {
  const additions =
    Number(data?.special_income || 0) +
    Number(data?.realised_installment || 0) +
    Number(data?.prev_cash_in_hand_paid || 0) +
    Number(data?.sold_assets || 0) +
    Number(data?.retrieved_assets || 0) +
    Number(data?.total_processing_fee || 0) +
    Number(data?.total_admin_fee || 0) +
    Number(data?.total_form_fee || 0) +
    Number(data?.total_affidavit_fee || 0) +
    Number(data?.total_insurance_fee || 0) +
    Number(data?.advanced_payment) +
    Number(data?.rollover_paid);

  return additions;
};

export const getCashInHand = (data) => Number(data?.cash_in_hand);

export const getSummationOfFields = ({
  data = [],
  fieldsToSum = [],
  fieldWithHandlers = {},
}) => {
  const summedFields = {};
  for (let index = 0; index < data.length; index++) {
    const isLastRound = index + 1 === data.length;
    const dataInstance = data[index];

    // Loop through all the fieldsToSum and increaments the summedFields fields with it.
    fieldsToSum?.forEach((field) => {
      if (fieldWithHandlers[field]) {
        summedFields[field] =
          (summedFields[field] || 0) +
          Number(fieldWithHandlers[field](dataInstance) || 0);
        if (isLastRound) {
          summedFields[field] = Number(summedFields[field]).toLocaleString();
        }
        return;
      }
      summedFields[field] =
        (summedFields[field] || 0) + Number(dataInstance[field]);

      if (isLastRound) {
        summedFields[field] = Number(summedFields[field]).toLocaleString();
      }
    });
  }

  return summedFields;
};

export const getDashboardUrlWithParam = ({
  isOrgDashboard,
  path,
  orgType,
  id,
  orgName,
  userOrgField,
  user,
  prefixPath = "org",
  extraParams = ""
}) => {
  if (isOrgDashboard) {
    return `/${prefixPath}/${orgType}/${id}/${path}?org=${orgType}&name=${orgName}`.concat(extraParams ? `&${extraParams}` : '');
  }
  
  return `/${path}?org=${orgType || userOrgField}&name=${
    user[userOrgField]?.name || ""
  }`.concat(extraParams ? `&${extraParams}` : '');
};


export const isOneMonthApart = (date1, date2) => {
  const diff = moment(date1).diff(moment(date2), 'days');
  return diff >= 30;
}

// export const isSameMonthAndLater = (date1, date2) => {
//   return moment(date1).isSame(moment(date2), 'month') && moment(date1).isAfter(moment(date2));
// }

export const isSameMonthAndLater = (date1, date2) => {
  const diff = moment(date1).diff(moment(date2), 'days');
  return Math.abs(diff) <= 30 && moment(date1).isAfter(moment(date2));
}


export const getTotalCashbackCount = (loan) => {
  let count = 0

  loan?.monthly_payment_data?.forEach((instance) => {
    if (instance?.status === "Paid") {
      const lastPayDate = instance?.payment_records?.[instance?.payment_records?.length - 1]?.date;

      if (isOneMonthApart(instance?.date, lastPayDate) || isSameMonthAndLater(instance?.date, lastPayDate)) {
        count = count + 1
      }
    }
  })

  return count
}

export const getIdFieldAndId = (orgType, orgId, user) => {
  let id_field=""
  let id=""

  if (orgType) {
    id_field = getOrgDashboardIdField(orgType)
    id = orgId || user?.branch?.id
  }

  return {
    org_id_field: id_field,
    org_id: id,
  }
}


/**
* Updates the old urls to the new aws bucket we are now using
*/
export const cleanedImage = (url) => {
  if (!url) return ""
  if (url.includes('compassionate-monthly3')) {
    return url
  }
  const oldBucketName = "compassionate-monthly"
  const newBucketName = "compassionate-monthly3"
  
  return url?.replace(oldBucketName, newBucketName)
}